import { render, staticRenderFns } from "./nginx_pz.md?vue&type=template&id=0788e031&"
import script from "./nginx_pz.md?vue&type=script&lang=js&"
export * from "./nginx_pz.md?vue&type=script&lang=js&"
import style0 from "./nginx_pz.md?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports